import React, { useState } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { stockWatchTestTelegram } from "../lib/api";
import { formatApiError } from "../lib/auth";

export function StockWatchTestButton() {
  const [sending, setSending] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      const res = await stockWatchTestTelegram();
      const ok = res.results.filter((r) => r.ok).length;
      const failed = res.results.filter((r) => !r.ok);
      if (failed.length) {
        toast.warning(`Enviado a ${ok}/${res.results.length}. Falló ${failed.map((f) => `${f.chat_id}: ${f.error}`).join(" | ")}`, { duration: 10000 });
      } else {
        toast.success(`Prueba enviada a ${ok}/${res.results.length} chats: ${res.results.map((r) => r.chat_id).join(", ")}`);
      }
    } catch (e) {
      toast.error(formatApiError(e) || "No se pudo enviar la prueba");
    }
    setSending(false);
  };

  return (
    <Button
      onClick={send}
      disabled={sending}
      className="rounded-none bg-[#0088cc] hover:bg-[#006ba6] text-white font-mono uppercase tracking-wider text-xs"
      data-testid="stock-watch-test-telegram-button"
    >
      <PaperPlaneTilt size={14} weight="bold" className={`mr-2 ${sending ? "animate-pulse" : ""}`} />
      {sending ? "Enviando..." : "Probar Telegram"}
    </Button>
  );
}
